module.exports = __webpack_public_path__ + "static/31-dfac4d2f361367825cb3684cc4b7fe01.jpg";